import { render, staticRenderFns } from "./order-confirmation-modal.vue?vue&type=template&id=ec91bfe6&scoped=true&lang=pug&"
import script from "./order-confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec91bfe6",
  null
  
)

export default component.exports